export default "__VITE_ASSET__BiahhmHU__"